module.exports = __webpack_public_path__ + "static/media/Slovakia.9ee08a3a.png";